<span class="ps-1 help">
    <ng-template #help>
        <div [innerHTML]="message"></div>
    </ng-template>
    <fa-icon [icon]="['fas', 'question-circle']" [size]='size'  placement="right" [ngbTooltip]="help" [placement]="placement" ></fa-icon>
</span>
